<div class="promo-t4-page">
    <!-- =========================================
       ENCABEZADO
  ========================================== -->
    <section class="promo-t4-header">
        <span class="promo-t4-eyebrow">
            PROMOCIÓN
        </span>
        <h1 class="promo-t4-title">
            {{ promo }}
        </h1>
        <p class="promo-t4-subtitle">
            Selecciona la cantidad de productos que deseas llevar.
        </p>
    </section>
    <!-- =========================================
       CONTENIDO
  ========================================== -->
    <section class="promo-t4-content">
        <!-- PRODUCTOS -->
        <div class="promo-t4-products" *ngIf="products.length > 0">
            <article class="promo-t4-product" *ngFor="let product of products">
                <!-- IMAGEN -->
                <div class="promo-t4-image">
                    <img [src]="product.urlFotoAgrupador || product.urlFoto" [defaultImage]="defImgProd"
                        [alt]="product.producto || 'Producto Nina'">
                </div>
                <!-- INFORMACIÓN -->
                <div class="promo-t4-info">
                    <h2 class="promo-t4-product-name">
                        {{ product.producto }}
                    </h2>
                    <p class="promo-t4-product-description" *ngIf="product?.productoAgrupador">
                        {{ product?.descripcionProducto }}
                    </p>
                </div>
                <!-- CANTIDAD -->
                <div class="promo-t4-quantity">
                    <span class="promo-t4-quantity-label">
                        CANTIDAD
                    </span>
                    <div class="promo-t4-quantity-controls">
                        <button mat-mini-fab class="promo-t4-qty-button" type="button" aria-label="Menos"
                            (click)="changeQty('restar', product)">
                            <mat-icon>remove</mat-icon>
                        </button>
                        <div class="promo-t4-qty-value">
                            {{ product.qty ? product.qty : 0 }}
                        </div>
                        <button mat-mini-fab class="promo-t4-qty-button" type="button" aria-label="Más"
                            (click)="changeQty('sumar', product)">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </article>
        </div>
        <!-- ACCIÓN -->
        <aside class="promo-t4-action">
            <button class="promo-t4-continue" mat-raised-button type="button" (click)="proceder()"
                [disabled]="selectedProductsCart.length === 0">
                CONTINUAR
            </button>
        </aside>
    </section>
</div>